<template>
  <div class="calendar_body">
    <div
      v-for="(week, row) in daysInMonth"
      :key="'w_' + row"
      class="calendar_body_row"
    >
      <calendar-body-day
        v-for="(day, idxDay) in week"
        :key="'d_' + idxDay"
        :day="day"
        :day-data="getDayData(row, idxDay, day)"
        :selected-item-id="selectedItemId"
        :is-sunday="idxDay === 0"
        :is-another-month="isAnotherMonth(row, day)"
        :day-string="getDayString(row, idxDay, day)"
        @click-item-day="handleClickItem"
      />
    </div>
  </div>
</template>

<script>
import CalendarBodyDay from './calendar-body-day';

export default {
  components: { CalendarBodyDay },
  props: {
    month: {
      type: Number,
      default: () => {
        return (new Date()).getMonth() + 1;
      },
    },
    year: {
      type: Number,
      default: () => {
        return (new Date()).getFullYear();
      },
    },
    monthData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    daysInMonth: {
      type: Array,
      default: () => {
        return [];
      },
    },
    monthRelative: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedItemId: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {
    getDayString(row, idxDay, day) {
      var currentDay = day < 10 ? '0' + day : day;
      return this.monthRelative[row][idxDay] + '-' + currentDay;
    },
    getDayData(row, idxDay, day) {
      /* if ((row === 0 && day > 20) || (row === 5 && day < 10)) {
        return [];
      }
      let index = '' + day;
      if (day < 10) {
        index = '0' + day;
      }*/
      var index = this.getDayString(row, idxDay, day);
      return this.monthData[index];
    },
    isAnotherMonth(row, day) {
      if ((row === 0 && day > 20) || (row === 5 && day < 10)) {
        return true;
      }
      return false;
    },
    handleClickItem(data) {
      this.selectedItemId = data.id;
      this.$emit('click-item-body', data);
    },
  },
};
</script>
